import { AxiosResponse } from "axios";
import { api } from "./base/api";
import {
	QuoteItemMappingPartViewReponse,
	MappingPartDetailViewResponse,
	CancelableQuoteItemsResponse,
	PartInfoByQuoteResponse,
} from "../models/response";
import { Result } from "../models/common/resultResponse";
import {
	GetCancelableQuoteItemsRequest,
	GetPartInfosByQuoteRequest,
	GetPredictRequest,
	MapPartInventoryRequest,
	MapPartRequest,
	MappingPartDetailInventoryRequest,
} from "../models/request";
import { PaginationResponse } from "../models/common/paginationResponse";
import { PaginationRequest } from "../models/common/paginationRequest";
import { IQuoteItemApi } from "./base";
import { TimeoutRequestConfigurationEnum } from "../services/enum/TimeoutRequestConfigurationEnum";

const baseRoute: string = "Quoteitem";

export class QuoteItemApi extends IQuoteItemApi {
	private activeAbortController: AbortController | null = null;

	getMappingParts(
		request: PaginationRequest,
	): Promise<AxiosResponse<PaginationResponse<QuoteItemMappingPartViewReponse>, any>> {
		return api.get(`${baseRoute}/getMappingParts`, { params: request });
	}
	getMappingPartDetail(request: GetPredictRequest): Promise<AxiosResponse<Result<MappingPartDetailViewResponse>, any>> {
		return api.get(`${baseRoute}/getMappingPartDetail`, { params: request });
	}
	saveMappingPart(request: MapPartRequest): Promise<AxiosResponse<Result<void>, any>> {
		return api.post(`${baseRoute}/savemappingpart`, request);
	}
	async getMappingPartDetailInventory(
		request: MappingPartDetailInventoryRequest,
	): Promise<AxiosResponse<Result<MappingPartDetailViewResponse>, any>> {
		if (this.activeAbortController) {
			this.activeAbortController.abort();
		}
		this.activeAbortController = new AbortController();

		const response = await api.get(`${baseRoute}/getmappingpartdetailinventory`, {
			params: request,
			signal: this.activeAbortController.signal,
			timeout: TimeoutRequestConfigurationEnum.ThreeMinutesInMilliseconds,
		});
		this.activeAbortController = null;
		return response;
	}

	saveMappingPartInventory(request: MapPartInventoryRequest): Promise<AxiosResponse<Result<void>, any>> {
		return api.post(`${baseRoute}/savemappingpartinventory`, request);
	}
	getCancelableQuoteItems(
		request: GetCancelableQuoteItemsRequest,
	): Promise<AxiosResponse<Result<CancelableQuoteItemsResponse>>> {
		return api.get(`${baseRoute}/getCancelableQuoteItems`, { params: request });
	}

	saveMappingPartDiscarted(request: MapPartRequest): Promise<AxiosResponse<Result<void>, any>> {
		return api.post(`${baseRoute}/savemappingpartdiscarted`, request);
	}

	getPartInfosByQuote(request: GetPartInfosByQuoteRequest): Promise<AxiosResponse<Result<PartInfoByQuoteResponse[]>>> {
		return api.get(`${baseRoute}/get-part-infos-by-quote`, {
			params: request,
		});
	}
}
